import { render } from "./PaymentSetting.vue?vue&type=template&id=2b38c04b&scoped=true"
import script from "./PaymentSetting.vue?vue&type=script&lang=js"
export * from "./PaymentSetting.vue?vue&type=script&lang=js"

import "./PaymentSetting.vue?vue&type=style&index=0&id=2b38c04b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b38c04b"]])

export default __exports__